
export default {
  knowledgeId: (state) => state.knowledgeId,
  timeoutTime: (state) => state.timeoutTime,
  timeout: (state) => state.timeout,
  link: (state) => state.link,
  isGenerating: (state) => state.isGenerating
};
